










import {Component, Vue} from 'vue-property-decorator';
import DynamicComponents from '@/components/DynamicComponents.vue';
import {SDynamicComponent} from '@/components/dto/SDynamicComponent';
import {ScomponentMode} from '@/components/dto/ScomponentMode';
import {ScomponentModeImpl} from '@/components/dto/ScomponentModeImpl';
@Component({
    components: {DynamicComponents}
})
export default class Registration extends Vue {
    private mode: ScomponentMode = ScomponentModeImpl.prototype.empty();
    private schema: SDynamicComponent[] = this.formSchema();
    private data: any = this.formData();

    handle_function_call(e: any) {
        //@ts-ignore
        this[e]();
    };


    registration(){
        let registration = {
            username: this.data.username.value,
            password: this.data.password.value,
            confirm_password: this.data.confirm_password.value,
            email: this.data.email.value,
            name: this.data.name.value
        };

        this.$store.dispatch('registration', registration).then(() => {
            this.$router.push({name: 'login'});
        }).catch(err => {
            console.log(err);
        });

    }

    formData(): any {
        return {"username": {
                "value": ''
            },
            "name":{
                "value": ''
            },
            "email": {
                "value": ''
            },
            "password": {
                "value": ''
            },
            "confirm_password": {
                "value": ''
            }

        };
    }

    formSchema() : SDynamicComponent[]{
        return [{
            "component": {
                "uid": "",
                "name": "Container",
                "url": "http://localhost:5000/container.umd.min.js"
            },
            "data": {
                "tag": "div",
                "fluid": false,
                "body": [{
                    "component": {
                        "uid": "",
                        "name": "Form",
                        "url": "http://localhost:5000/form.umd.min.js"
                    },
                    "data": {
                        "body": [{
                            "component": {
                                "uid": "",
                                "name": "Card",
                                "url": "http://localhost:5000/card.umd.min.js"
                            },
                            "data": {

                                "title": "Registration",
                                "body": [{
                                    "component": {
                                        "uid": "",
                                        "name": "FormGroup",
                                        "url": "http://localhost:5000/form-group.umd.min.js"
                                    },

                                    "data": {
                                        "id": "fieldset-username",
                                        "label": "Login name:",
                                        "label_cols" : 4,
                                        "label_cols_lg": 2,
                                        "label_for": "username",
                                        "state": false,
                                        "invalid_feedback": "invalid_feedback",
                                        "body":[
                                            {
                                                "component": {
                                                    "uid": "",
                                                    "name": "FormInput",
                                                    "url": "http://localhost:5000/form-input.umd.min.js"
                                                },
                                                "data": {
                                                    "id": "username",
                                                    "name": "username_",
                                                    "required": true,
                                                    "placeholder": "Your login name",
                                                    "body": []
                                                },
                                                "componentMode":{editable:false,delete:false,addHint:false, moveComponent:false}
                                            }
                                        ]
                                    },
                                    "componentMode":{editable:false,delete:false,addHint:false, moveComponent:false}
                                },{
                                    "component": {
                                        "uid": "",
                                        "name": "FormGroup",
                                        "url": "http://localhost:5000/form-group.umd.min.js"
                                    },
                                    "data": {
                                        "id": "fieldset-name",
                                        "label": "Name:",
                                        "label_cols" : 4,
                                        "label_cols_lg": 2,
                                        "label_for": "name",
                                        "body":[
                                            {
                                                "component": {
                                                    "uid": "",
                                                    "name": "FormInput",
                                                    "url": "http://localhost:5000/form-input.umd.min.js"
                                                },
                                                "data": {
                                                    "id": "name",
                                                    "name": "name_",
                                                    "required": true,
                                                    "placeholder": "Your name",
                                                    "body": []
                                                },
                                                "componentMode":{editable:false,delete:false,addHint:false, moveComponent:false}
                                            }
                                        ]
                                    },
                                    "componentMode":{editable:false,delete:false,addHint:false, moveComponent:false}
                                },{
                                    "component": {
                                        "uid": "",
                                        "name": "FormGroup",
                                        "url": "http://localhost:5000/form-group.umd.min.js"
                                    },
                                    "data": {
                                        "id": "fieldset-email",
                                        "label": "Email:",
                                        "label_cols" : 4,
                                        "label_cols_lg": 2,
                                        "label_for": "email",
                                        "body":[
                                            {
                                                "component": {
                                                    "uid": "",
                                                    "name": "FormInput",
                                                    "url": "http://localhost:5000/form-input.umd.min.js"
                                                },
                                                "data": {
                                                    "id": "email",
                                                    "name": "email_",
                                                    "required": true,
                                                    "placeholder": "Your email",
                                                    "body": []
                                                },
                                                "componentMode":{editable:false,delete:false,addHint:false, moveComponent:false}
                                            }
                                        ]
                                    },
                                    "componentMode":{editable:false,delete:false,addHint:false, moveComponent:false}
                                },{
                                    "component": {
                                        "uid": "",
                                        "name": "FormGroup",
                                        "url": "http://localhost:5000/form-group.umd.min.js"
                                    },
                                    "data": {
                                        "id": "fieldset-password",
                                        "label": "Password:",
                                        "label_cols" : 4,
                                        "label_cols_lg": 2,
                                        "label_for": "password",
                                        "body":[
                                            {
                                                "component": {
                                                    "uid": "",
                                                    "name": "FormInput",
                                                    "url": "http://localhost:5000/form-input.umd.min.js"
                                                },
                                                "data": {
                                                    "id": "password",
                                                    "name": "password_",
                                                    "required": true,
                                                    "placeholder": "Your password",
                                                    "type": "password",
                                                    "body": []
                                                },
                                                "componentMode":{editable:false,delete:false,addHint:false, moveComponent:false}
                                            }
                                        ]
                                    },
                                    "componentMode":{editable:false,delete:false,addHint:false, moveComponent:false}
                                },{
                                    "component": {
                                        "uid": "",
                                        "name": "FormGroup",
                                        "url": "http://localhost:5000/form-group.umd.min.js"
                                    },
                                    "data": {
                                        "id": "fieldset-confirm_password",
                                        "label": "Confirm password:",
                                        "label_cols" : 4,
                                        "label_cols_lg": 2,
                                        "label_for": "confirm_password",
                                        "body":[
                                            {
                                                "component": {
                                                    "uid": "",
                                                    "name": "FormInput",
                                                    "url": "http://localhost:5000/form-input.umd.min.js"
                                                },
                                                "data": {
                                                    "id": "confirm_password",
                                                    "name": "confirm_password_",
                                                    "required": true,
                                                    "placeholder": "Confirm password",
                                                    "type": "password",
                                                    "body": []
                                                },
                                                "componentMode":{editable:false,delete:false,addHint:false, moveComponent:false}
                                            }
                                        ]
                                    },
                                    "componentMode":{editable:false,delete:false,addHint:false, moveComponent:false}
                                },
                                    {
                                        "component": {
                                            "uid": "",
                                            "name": "Button",
                                            "url": "http://localhost:5000/button.umd.min.js"
                                        },
                                        "data": {
                                            "button_text": "Registration",
                                            "variant": "primary",
                                            "type": "submit",
                                            "size": "",
                                            "fn_name": "registration"
                                        },
                                        "componentMode":{editable:false,delete:false,addHint:false, moveComponent:false}
                                    },{
                                        "component": {
                                            "uid": "",
                                            "name": "Button",
                                            "url": "http://localhost:5000/button.umd.min.js"

                                        },
                                        "data": {
                                            "uid": 122,
                                            "button_text": "Login",
                                            "to": {name : "login"}
                                        },
                                        "componentMode":{editable:false,delete:false,addHint:false, moveComponent:false}
                                    }
                                ],
                            },
                            "componentMode":{editable:false,delete:false,addHint:false, moveComponent:false}
                        }]
                    },
                    "componentMode":{editable:false,delete:false,addHint:false, moveComponent:false}
                }]
            },
            "componentMode":{
                "editable": false,
                "delete": false,
                "addHint": false,
                "moveComponent": false
            }
        }]
    }

}
